import React from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import App from './App';
import { initMocks } from './test/server';

initMocks();

const root = createRoot(document.getElementById('root') as Element);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
